import { Box, Typography } from "@mui/material";
import Datacard from "../../../../components/Datacard";
import NoDataImg from "../../../../assets/TransactionDashboardIcons/Nothing.png";
import OwnerDashboardAccountList from "../../../../components/Accounts/OwnerAccounts/DashboardAccountList";
import DashboardCreateDiv from "../../../../components/Accounts/Common/DashboardCreateDiv";

const AccountOwnerDataCardComponent = ({ dashboardData }) => {
  const validDataCards = () => {
    if (Object.keys(dashboardData).length === 0) {
      return {};
    }
    const {
      failed_to_activate_accounts_details,
      blocked_accounts_details,
      archived_accounts_details,
      pending_accounts_details,
    } = dashboardData;
    return {
      failed_to_activate_accounts_details,
      blocked_accounts_details,
      archived_accounts_details,
      pending_accounts_details,
    };
  };
  const cardTextColor = (key) => {
    if (key === "pending_accounts_details") {
      return "#fb923c";
    } else if (key === "failed_to_activate_accounts_details") {
      return "#fb923c";
    } else if (key === "blocked_accounts_details") {
      return "#FF5860";
    } else if (key === "archived_accounts_details") {
      return "#B4B4B4";
    }
  };

  const cardTextData = (key) => {
    if (key === "pending_accounts_details") {
      return "Awaiting activation";
    } else if (key === "failed_to_activate_accounts_details") {
      return "Account deactivated";
    } else if (key === "blocked_accounts_details") {
      return "Blocked accounts";
    } else if (key === "archived_accounts_details") {
      return "Archived accounts";
    }
  };

  const cardPath = (key) => {
    if (key === "pending_accounts_details") {
      return "/accounts/owner/view/P";
    } else if (key === "failed_to_activate_accounts_details") {
      return "/accounts/owner/view/F";
    } else if (key === "blocked_accounts_details") {
      return "/accounts/owner/view/Blocked";
    } else if (key === "archived_accounts_details") {
      return "/accounts/owner/view/Archived";
    }
  };

  const processDataCardDetails = () => {
    let dataCards = validDataCards();
    return Object.entries(dataCards).map(([key, value]) => {
      return {
        key: key,
        count: value.records,
        color: cardTextColor(key),
        text: cardTextData(key),
        path: cardPath(key),
      };
    });
  };

  const dataCardComponents = () => {
    return Object.entries(processDataCardDetails()).map(([key, data]) => {
      return (
        <Datacard
          key={key}
          number={data.count}
          color={data.color}
          text={data.text}
          path={data.path}
        />
      );
    });
  };

  return dataCardComponents();
};

const AccountOwnerListComponent = ({ accountType, viewAllData }) => {
  const emptyAccountListComponent = () => {
    return (
      <>
        <Typography sx={{ color: "white" }}>
          No accounts found <br />
          All vendor accounts will appear here.
        </Typography>
        <Box
          sx={{
            width: "50%",
            margin: "auto",
            marginTop: "5%",
          }}
        >
          <img width={"100%"} src={NoDataImg} alt="NoDataImg" />
        </Box>
      </>
    );
  };

  const listTextColor = (key) => {
    if (key === "Y") {
      return "#4DDD37";
    } else if (key === "N") {
      return "#FF5860";
    } else if (key === "F") {
      return "#fb923c";
    } else if (key === "Blocked") {
      return "#FF5860";
    } else if (key === "D") {
      return "#FF5860";
    } else if (key === "Archived") {
      return "#B4B4B4";
    } else if (key === "P") {
      return "#fb923c";
    }
  };

  const modifiedAccountListData = () => {
    return Object.entries(viewAllData).map(([key, value]) => {
      return {
        account_number: value.bank_acc_no,
        bank_name: value.bank_name,
        balance: value.available_balance,
        last_fetched_at: value.last_fetched_balance,
        text_color: listTextColor(value.approval_status, value.hdfc_umrn),
        owner_id: value.owner_id,
      };
    });
  };

  const accountListComponents = () => {
    if (Object.keys(viewAllData).length === 0) {
      return emptyAccountListComponent();
    } else {
      return (
        <>
          <div className="px-4 flex flex-row justify-between">
            <span className="text-white text-xl 3xl:text-2xl 4xl:text-3xl 5xl:text-4xl">
              Recent
            </span>
            <span className="cursor-pointer text-xl 3xl:text-2xl 4xl:text-3xl 5xl:text-4xl">
              <p
                onClick={() =>
                  (window.location.href = `/accounts/${accountType}/view/`)
                }
                className="underline text-custom-orange"
              >
                View All
              </p>
            </span>
          </div>

          <div className="pb-6 3xl:pb-8 5xl:pb-10 mt-5 w-full gap-y-4 4xl:gap-y-8 grid grid-cols-1 md:grid-cols-2 3xl:grid-cols-3 md:gap-x-8 lg:gap-x-10 justify-items-center">
            {Object.entries(modifiedAccountListData()).map(([key, value]) => {
              return (
                <OwnerDashboardAccountList
                  key={key}
                  accountNumber={value.account_number}
                  bankName={value.bank_name}
                  balance={value.balance}
                  lastFetchedAt={value.last_fetched_at}
                  textColor={value.text_color}
                  navigate_url={`/accounts/${accountType}/details/${value.owner_id}`}
                />
              );
            })}
          </div>
        </>
      );
    }
  };

  return accountListComponents();
};

const AccountOwnerRightSidebarComponent = () => {
  const rightSidebarComponents = () => {
    return (
      <>
        <div>
          {
            <DashboardCreateDiv
              heading={"Start creating your accounts"}
              first_button_text={"Create"}
              second_button_text={"View all"}
              first_button_url={"/accounts/owner/create"}
              second_button_url={"/accounts/owner/view/"}
            />
          }
        </div>
      </>
    );
  };

  return rightSidebarComponents();
};

export {
  AccountOwnerDataCardComponent,
  AccountOwnerListComponent,
  AccountOwnerRightSidebarComponent,
};
